<div *ngIf="access" class="project-comments-form">
    <core-message-add
          [action]="addUrl"
          (onSaved)="onSaved($event)">
      </core-message-add>
  </div>